export default Object.freeze({
    PROFILE_SECTOR_MAX_LEN: 32,                 // 経験業界 最大桁数
    PROFILE_SPECIALTY_SUMMARY_MAX_LEN: 41,      // 得意分野_概要 最大桁数
    PROFILE_SPECIALTY_DESCRIPTION_MAX_LEN: 400, // 得意分野_説明 最大桁数
    PROFILE_NOTICES_MAX_LEN: 98,                // 特記事項 最大桁数
});